import { makeStyles } from 'tss-react/mui';

const name = 'Buttons';

export const useButtonsStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    gap: theme.spacing(3),
  },
}));
